<template>
  <v-main class="bg-bg-primary pa-0 ma-0" >
    <v-container fluid class="pa-0 d-flex fill-height" style="min-height: 100vh;">

      <slot />
    </v-container>
  </v-main>
</template>
